import { bindable, bindingMode, computedFrom, customElement } from "aurelia-framework";
import Litepicker from "litepicker";

@customElement("date-range-picker")
export class DateRangePicker {
    @bindable({ defaultBindingMode: bindingMode.twoWay })
    private selectedDateRange: { from: Date; to: Date };

    private datePickerElement: HTMLDivElement;
    private showDatePicker = false;
    private datePicker: Litepicker;

    @computedFrom("selectedDateRange.from", "selectedDateRange.to")
    public get datePickerName(): string {
        return this.getDatePickerName();
    }

    public attached(): void {
        if (!this.datePicker) {
            this.datePicker = new Litepicker({
                element: this.datePickerElement,
                singleMode: false,
                position: "bottom",
                tooltipText: {
                    one: "day",
                    other: "days",
                },
                setup: (picker) => {
                    picker.on("before:render", (ui) => {
                        const button = document.createElement("button");
                        button.className = "btn btn-sm btn-default";
                        button.style.float = "right";
                        button.innerText = "Clear";
                        button.addEventListener("click", (evt) => {
                            evt.preventDefault();

                            this.selectedDateRange = null;
                            picker.clearSelection();
                            this.datePicker.hide();
                        });
                        if (ui.querySelector(".month-item")) {
                            window.requestAnimationFrame(() => {
                                ui.querySelector(".month-item").appendChild(button);
                            });
                        }
                    });
                    picker.on("preselect", (date1, date2) => {
                        if (date1 && date2) {
                            this.selectedDateRange = { from: date1.dateInstance, to: date2.dateInstance };
                        }
                    });
                    picker.on("show", () => {
                        this.showDatePicker = true;
                    });
                    picker.on("hide", () => {
                        // Use requestAnimationFrame function to make setting this.showDatePicker asynchronously, otherwise when click the selectDate button again,
                        // the toggleSelectDate() will be called after we set this.showDatePicker = false and reopen the picker again
                        window.requestAnimationFrame(() => {
                            this.showDatePicker = false;
                        });
                    });
                },
            });
        }
    }

    private getDatePickerName(): string {
        if (!this.selectedDateRange) {
            return "Select Date";
        }

        // return date range with format dd-MMM
        const options = { day: "2-digit" as const, month: "short" as const };
        const fromDate = this.selectedDateRange.from.toLocaleDateString("en-US", options);
        const toDate = this.selectedDateRange.to.toLocaleDateString("en-US", options);

        if (fromDate === toDate) {
            return fromDate;
        }

        return fromDate + " - " + toDate;
    }

    toggleSelectDate(event: Event): void {
        if (this.showDatePicker) {
            this.datePicker.hide();
        } else {
            this.datePicker.show();
        }
        event.stopPropagation();
    }
}
